import React from 'react';

const Bar = props => {
    const amt = props.completed || 0;

    // Vertical layout
    let animationClass = 'completed-vertical';
    let yStart = 100 - amt;
    let height = amt;
    let width = 100;

    // Horizontal layout
    if (props.orientation === 'horizontal') {
        animationClass = 'completed-horizontal';
        yStart = 0;
        height = 100;
        width = amt;
    }

    let className = 'Bar';
    if (props.status) {
        className += ` Bar-${props.status}`;
    } else {
        className += ` Bar-danger`;
    }

    return (
        <svg
            className={className}
            viewBox="0 0 100 100"
            preserveAspectRatio="none">
            <rect className="background" x="0" y="0" width="100" height="100" />
            <g className={animationClass}>
                <rect
                    className="completed"
                    x="0"
                    y={yStart}
                    width={width}
                    height={height}
                />
            </g>
        </svg>
    );
};

export default Bar;
